import { ChangeDetectionStrategy, Component, DOCUMENT, effect, inject } from '@angular/core';
import { RouterModule } from '@angular/router';

import { Settings } from './service/settings';

@Component({
  selector: 'lcm-app',
  template: '<router-outlet />',
  imports: [RouterModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'theme()',
  },
})
export class App {
  private document = inject(DOCUMENT);
  readonly theme = inject(Settings).theme;

  _ = effect(() => {
    const theme = this.theme();
    document.body.dataset['theme'] = theme;
  });
}
